import { render, staticRenderFns } from "./AssignStudent.vue?vue&type=template&id=770eff8d"
import script from "./AssignStudent.vue?vue&type=script&lang=js"
export * from "./AssignStudent.vue?vue&type=script&lang=js"
import style0 from "./AssignStudent.vue?vue&type=style&index=0&id=770eff8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports